import React from 'react';

/** Dash plus small-caps label. The surface it sits on picks the colour (design-system.css). */
const Eyebrow: React.FC<{ children: React.ReactNode; className?: string }> = ({ children, className }) => (
  <p className={className ? `ui-eyebrow ${className}` : 'ui-eyebrow'}>{children}</p>
);

export default Eyebrow;
